import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import ProductCard from "@/components/Cards/ProductCard";
import Loader from "@/components/Loader/loader";
import React, { useEffect } from "react";

const Product: React.FC = () => {

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: "/v1/gp/67850933e23ada9e6aa61f3c/tr/find?list_related=false&list_referenced=false&module_populate=677e1e70c44fb038b4a85a34&skip=0&search=parentId%3A%24eq%3Anull",
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    })

    const {
        data: allDatas,
        isLoading: loading,
    } = useFetchApi({
        url: "/v1/gp/67850933e23ada9e6aa61f3c/tr/find?list_related=false&list_referenced=false&module_populate=677e19dbc44fb038b4a85676&limit=0&skip=0",
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    });


    useEffect(() => {
        if (loading || !allDatas?.results || allDatas.results.length === 0) {
            return;
        }

        const cp_data = allDatas.results;

        const handleRecursive = (baseData: any) => {
            let { _id } = baseData;
            const children = cp_data.filter((item: any) => item.parentId?._id === _id);
            return {
                ...baseData,
                children: children.map((child: any) => handleRecursive(child)),
            };
        };

        const result = handleRecursive(cp_data[0]);
        console.log(result["children"]);
    }, [loading, allDatas]);

    return (
        <>
            <BreadCrumb title="Ürünler" parent="Ürünler" child="" />

            {/* {(allDatas.length > 0) && ( */}
            <section className="ls section_padding_top_135 section_padding_bottom_90 columns_padding_25">
                <div className="container">
                    <div className="row columns_margin_bottom_40 services-row">
                        {!isLoading && data ? (
                            data?.results?.map((record: any, index: number) => (
                                <ProductCard
                                    key={record._id}
                                    data={{
                                        title: record.title,
                                        dosya: record.dosya,
                                        content: record.content,
                                        icon: record.icon,
                                        fix_name: record.fix_name,
                                        pageName: "product",
                                        url: "/urunler-liste/" + index
                                    }}
                                    isLoading={false}
                                />
                            ))
                        ) : (
                            <p><Loader /></p>
                        )}
                    </div>
                </div>
            </section>
            {/* )} */}

            {/* {all_products.length > 0 && (
                <section>
                    products
                </section>
            )} */}
        </>
    )
}

export default Product;